import { User } from '@bizzabo/entities';
import { Channel, StreamChat, UserResponse } from 'stream-chat';
import { StreamMessage } from 'stream-chat-react';

export const extractChatPartner = (channel: Channel, client: StreamChat) => {
    const { members } = channel.state;
    let chatPartners = Object.values(members).filter(({ user }) => user.id !== client.userID);
    if (chatPartners.length === 0) {
        // in case this is a channel of one attendee
        chatPartners = [members[client.userID]];
    }
    return chatPartners?.[0]?.user as UserResponse<User>;
};

export const getPartnerName = (message: StreamMessage) => {
    return message.user?.name?.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
};
